import clsx from "clsx";
import {Logo, SimpleLogo} from "components/logos";
import Transition from "components/Transition";
import AuthenticationForm from "containers/SignInOutForm/Form";
import {useStickyState} from "contexts/app/app.provider";
import {AuthContext} from "contexts/auth/auth.provider";
import {ModalContext} from "contexts/modal.provider";
import {SearchContext} from "contexts/search/search.provider";
import {useFormik} from "formik";
import {useRouter} from "next/router";
import React, {useContext, useState} from 'react';
import Sticky from "react-stickynode";
import styled from "styled-components";
import * as Yup from "yup";

const MenuItem = styled.a`
    font-size: 14px;
    font-weight: 500;
    font-family: Montserrat;
    color: #888888!important;
`;
const TopNav = styled.div`
    min-height: 90px;
    @media (max-width: 640px) {
      min-height: 80px;
    }
`;


export default function ShopContainer({children}) {
    const router = useRouter();
    const [showSearch, setShowSearch] = useState(false);
    const [dropdown, setDropdown] = useState(false);
    const [mobileMenu, setMobileMenu] = useState(false);
    const [showTopMenu,] = useState(false);
    const {user, logout, authDispatch} = useContext(AuthContext);
    const isSticky = useStickyState('isSticky');
    const {search, setSearch} = useContext(SearchContext);

    const {openModal} = useContext(ModalContext);

    function onSignout() {
        logout().then(() => window.location.href = process.env.BASE_URL);
    }


    function toggleLoginModal() {
        openModal({
            content: <AuthenticationForm/>,
            classes: "z-1600 w-full sm:w-2/3 md:w-1/2 lg:w-2/5 xl:w-1/4",
            onClose: () => {
                // silly implementation to reset the popup window to login in case it changed....
                authDispatch({
                    type: 'SIGNIN',
                });
            }
        });
    }

    function toggleSearch() {
        setShowSearch(d => !d);
    }

    function onProfileClick() {
        setDropdown(d => !d);
    }

    function onMenuClick() {
        setMobileMenu(d => !d);
    }

    const {getFieldProps, handleSubmit, values, setFieldValue, isValid,} = useFormik({
        enableReinitialize: true,
        initialValues: search || {},
        onSubmit: (values) => {
            setSearch(values);
            toggleSearch();
            window.scrollTo(0, 0);
        },
        validationSchema: Yup.object().shape({
            text: Yup.string()
                .required('required'),
        })
    });

    return (<>
            <div className="min-h-screen">

                <Transition
                    show={showSearch}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                    appear={true}
                >
                    <div className="fixed inset-0 transition-opacity z-600">
                        <div className="absolute inset-0 bg-gray-500 opacity-75 z-1800" onClick={toggleSearch}/>
                    </div>
                </Transition>


                <Sticky enabled={isSticky} innerZ={1001}>
                    <nav className={clsx(isSticky ? 'sticky' : 'unSticky', "bg-white shadow")}>
                        <TopNav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center">


                            <div className="flex  justify-between items-center">
                                <div className="logo flex-shrink-0 flex items-center">
                                    <a href="/" style={{height: 70}}>
                                        <SimpleLogo className="w-auto h-full"/>
                                    </a>
                                </div>
                            </div>

                            <nav className="hidden md:flex space-x-10">


                                <ul className="flex">

                                    <li className="">
                                        <MenuItem
                                            href="/"
                                            className="relative block py-6 px-4 lg:p-6 text-sm lg:text-base text-gray-400 font-medium  hover:text-yellow-500">
                                            Home
                                        </MenuItem>
                                    </li>
                                    <li className="">
                                        <MenuItem
                                            href="https://scuttle.co.za/faqs/"
                                            className="relative block py-6 px-4 lg:p-6 text-sm lg:text-base text-gray-400 font-medium  hover:text-yellow-500">
                                            FAQ's
                                        </MenuItem>
                                    </li>

                                    {/*Hoverable Link*/}
                                    {/* <li className="hoverable ">
                                        <MenuItem
                                            className="relative block py-6 px-4 lg:p-6 text-sm lg:text-base text-gray-400 font-medium hover:text-yellow-500"
                                        >
                                            Scuttle Events
                                        </MenuItem>
                                        <div
                                            className="p-6 mega-menu mb-16 sm:mb-0 shadow-xl bg-white absolute transform px-2 w-screen max-w-xs sm:px-0 transition ease-in-out duration-200">
                                            <div
                                                className="container mx-auto w-full flex flex-wrap justify-between mx-2 font-medium">
                                                <ul className="px-4 w-full text-gray-400 font-normal">


                                                    <li
                                                        className="cursor-pointer  mb-3 hover:text-yellow-500">
                                                        <a href="https://scuttle.co.za/scuttle-events/cavemanchallenge/">Caveman
                                                            Challenge Grabouw 2021</a></li>
                                                    <li
                                                        className="cursor-pointer  mb-3 hover:text-yellow-500">
                                                        <a href="https://www.scuttle.co.za/scuttle-events/tru-cape-mile/">
                                                            Tru-Cape Mile Swim 2021</a></li>

                                                    <li
                                                        className="cursor-pointer  mb-3 hover:text-yellow-500">
                                                        <a href="https://www.scuttle.co.za/scuttle-events/mountain-biking/great-white-mtb-trail-run/">Great
                                                            White MTB &amp; Trail Run</a></li>
                                                    <li
                                                        className="cursor-pointer  mb-3 hover:text-yellow-500">
                                                        <a href="https://www.capecrusadetrail.com/">Cape Crusade 3 Day
                                                            Trail
                                                            Run</a></li>
                                                    <li
                                                        className="cursor-pointer  mb-3 hover:text-yellow-500">
                                                        <a href="https://www.capecrosstri.com/">Cape Cross Triathlon
                                                            Stage
                                                            Race</a></li>
                                                    <li
                                                        className="cursor-pointer  mb-3 hover:text-yellow-500">
                                                        <a href="http://run2nowhere.co.za/">Run2Nowhere</a></li>
                                                    <li
                                                        className="cursor-pointer  mb-3 hover:text-yellow-500">
                                                        <a href="http://ride2nowhere.co.za/">Ride2Nowhere</a></li>

                                                    <li
                                                        className="cursor-pointer  mb-3 hover:text-yellow-500">
                                                        <a href="https://www.scuttle.co.za/scuttle-events/open-water-swim/">Lomond
                                                            Open Water Swim 2021</a></li>
                                                    <li
                                                        className="cursor-pointer mb-3 hover:text-yellow-500">
                                                        <a href="https://www.scuttle.co.za/scuttle-events/lomondtriathlon/">Lomond
                                                            Triathlon 2021</a></li>
                                                </ul>

                                            </div>
                                        </div>
                                    </li> */}

                                    {/*Hoverable Link*/}
                                    <li className="">
                                        <MenuItem
                                            href="https://www.scuttle.co.za/adventures-blog/"
                                            className="relative block py-6 px-4 lg:p-6 text-sm lg:text-base text-gray-400 font-medium hover:text-yellow-500"
                                        >
                                            Adventures
                                        </MenuItem>
                                        {/* <div
                                            className="p-6 mega-menu mb-16 sm:mb-0 shadow-xl bg-white absolute transform px-2 w-screen max-w-xs sm:px-0 transition ease-in-out duration-200">
                                            <div
                                                className="container mx-auto w-full flex flex-wrap justify-between mx-2">

                                                <ul className="px-4 w-full text-gray-400 font-normal">
                                                    <li className="cursor-pointer  mb-3 hover:text-yellow-500">
                                                        <a href="https://scuttle.co.za/adventures/#camping">Camping</a>
                                                    </li>
                                                    <li className="cursor-pointer  mb-3 hover:text-yellow-500">
                                                        <a href="https://scuttle.co.za/adventures/#hiking">Hiking</a>
                                                    </li>
                                                    <li className="cursor-pointer  mb-3 hover:text-yellow-500">
                                                        <a href="https://scuttle.co.za/adventures/#climbing">Climbing</a>
                                                    </li>
                                                    <li className="cursor-pointer  mb-3 hover:text-yellow-500">
                                                        <a href="https://scuttle.co.za/adventures/#kloofing">Kloofing
                                                            (Canyoning)</a></li>
                                                    <li className="cursor-pointer  mb-3 hover:text-yellow-500">
                                                        <a href="https://scuttle.co.za/adventures/#cabins%20&amp;%20cottages">Cabins &amp; Cottages</a>
                                                    </li>
                                                    <li className="cursor-pointer hover:text-yellow-500">
                                                        <a href="https://scuttle.co.za/adventures/#South%20African%20Nature%20Reserves">South
                                                            African Nature Reserves</a></li>
                                                </ul>
                                            </div>
                                        </div> */}
                                    </li>

                                    <li className="">
                                        <MenuItem
                                            href="https://www.scuttle.co.za/contact/"
                                            className="relative block py-6 px-4 lg:p-6 text-sm lg:text-base text-gray-400 font-medium  hover:text-yellow-500">
                                            Contact
                                        </MenuItem>
                                    </li>

                                    <li className="">
                                        <MenuItem
                                            href="https://www.scuttle.co.za/our-story/"
                                            className="relative block py-6 px-4 lg:p-6 text-sm lg:text-base text-gray-400 font-medium  hover:text-yellow-500">
                                            About Us
                                        </MenuItem>
                                    </li>
                                </ul>

                            </nav>
                            <div className="hidden sm:ml-6 sm:flex sm:items-center">


                                {
                                    user ?
                                        <div className="ml-3 relative">
                                            <div>
                                                <button
                                                    onClick={onProfileClick}
                                                    className="flex text-sm border-2 border-transparent rounded-full focus:outline-none focus:border-gray-300 transition duration-150 ease-in-out"
                                                    id="user-menu"
                                                    aria-label="User menu"
                                                    aria-haspopup="true"
                                                >
                                                    {
                                                        user?.attributes?.picture ?
                                                            <img
                                                                className="h-8 w-8 rounded-full"
                                                                src={user?.attributes?.picture}
                                                            />
                                                            :
                                                            <span
                                                                className="inline-flex items-center justify-center h-10 w-10 rounded-full bg-gray-500">
                                                  <span className="font-medium leading-none text-white">
                                                      {user?.attributes?.given_name && user?.attributes?.given_name[0]}{user?.attributes?.family_name && user?.attributes?.family_name[0]}
                                                  </span>
                                                </span>
                                                    }

                                                </button>
                                            </div>
                                            <Transition
                                                show={dropdown}
                                                enter="transition ease-out duration-200"
                                                enterFrom="transform opacity-0 scale-95"
                                                enterTo="transform opacity-100 scale-100"
                                                leave="transition ease-in duration-75"
                                                leaveFrom="transform opacity-100 scale-100"
                                                leaveTo="transform opacity-0 scale-95"
                                                appear={true}
                                            >
                                                <div
                                                    id="profile-menu"
                                                    className="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg">
                                                    <div className="py-1 rounded-md bg-white shadow-xs">
                                                        <a
                                                            href="/rent/account/orders"
                                                            className="cursor-pointer block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out"
                                                        >
                                                            My Orders
                                                        </a>
                                                        {user?.attributes && user?.attributes['custom:company'] &&
                                                        <a
                                                            href="/rent/admin/dashboard"
                                                            className="cursor-pointer block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out"
                                                            role="menuitem"
                                                        >
                                                            Admin Portal
                                                        </a>
                                                        }
                                                        <a
                                                            href="/rent/account/settings"
                                                            className="cursor-pointer block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out"
                                                        >
                                                            Account Settings
                                                        </a>
                                                        <a
                                                            onClick={onSignout}
                                                            className="cursor-pointer block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out"
                                                        >
                                                            Sign out
                                                        </a>
                                                    </div>
                                                </div>
                                            </Transition>
                                        </div>
                                        :
                                        <button
                                            type="button"
                                            onClick={toggleLoginModal}
                                            className="inline-flex items-center px-2.5 py-1.5 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-scuttle-blue hover:bg-blue-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 cursor-pointer"
                                        >
                                            Sign in
                                        </button>
                                }


                            </div>


                            {/* Mobile menu button */}
                            <div className="-mr-2 flex items-center md:hidden">
                                <div className="pl-4 flex items-center">
                                    <div onClick={toggleSearch} className="search-icon cursor-pointer p-2">
                                        <svg
                                            className="fill-current pointer-events-none text-grey-700 w-5 h-5 inline"
                                            xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                            <path
                                                d="M12.9 14.32a8 8 0 1 1 1.41-1.41l5.35 5.33-1.42 1.42-5.33-5.34zM8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12z"></path>
                                        </svg>
                                    </div>
                                </div>


                                {/* Mobile menu button */}
                                <button
                                    onClick={onMenuClick}
                                    className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 focus:text-gray-500 transition duration-150 ease-in-out">
                                    {/* Menu open: "hidden", Menu closed: "block" */}
                                    <svg
                                        className={clsx(mobileMenu ? "hidden" : "block", "h-6 w-6")}
                                        stroke="currentColor"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M4 6h16M4 12h16M4 18h16"
                                        />
                                    </svg>
                                    {/* Menu open: "block", Menu closed: "hidden" */}
                                    <svg
                                        className={clsx(mobileMenu ? "block" : "hidden", "h-6 w-6")}
                                        stroke="currentColor"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M6 18L18 6M6 6l12 12"
                                        />
                                    </svg>
                                </button>
                            </div>
                        </TopNav>

                        <div className={clsx(mobileMenu ? "block" : "hidden", "md:hidden")}>
                            {user && showTopMenu && <div className="pt-2 pb-3 space-y-1">
                                <a
                                    href="/rent/account/orders"
                                    className="block pl-3 pr-4 py-2 border-l-4 border-indigo-500 text-base font-medium text-indigo-700 bg-indigo-50 focus:outline-none focus:text-indigo-800 focus:bg-indigo-100 focus:border-indigo-700 transition duration-150 ease-in-out"
                                >
                                    My Orders
                                </a>

                            </div>}
                            <div className="pt-4 pb-3 border-t border-gray-200">
                                {user && <div className="flex items-center px-4 space-x-3">
                                    <div className="flex-shrink-0">
                                        {
                                            user?.attributes?.picture ?
                                                <img
                                                    className="h-10 w-10 rounded-full"
                                                    src={user?.attributes?.picture}
                                                />
                                                :
                                                <span
                                                    className="inline-flex items-center justify-center h-10 w-10 rounded-full bg-gray-500">
                                                  <span className="font-medium leading-none text-white">
                                                      {user?.attributes?.given_name && user?.attributes?.given_name[0]}{user?.attributes?.family_name && user?.attributes?.family_name[0]}
                                                  </span>
                                                </span>
                                        }
                                    </div>
                                    <div>
                                        <div className="text-base font-medium leading-6 text-gray-800">
                                            {user?.attributes?.given_name}
                                        </div>
                                        <div className="text-sm font-medium leading-5 text-gray-500">
                                            {user?.attributes?.email}
                                        </div>
                                    </div>
                                </div>}
                                <div
                                    className="space-y-1 text-center"
                                    role="menu"
                                    aria-orientation="vertical"
                                    aria-labelledby="user-menu"
                                >
                                    <a
                                        style={{
                                            transform: 'translate(0px, 0px)',
                                            opacity: 1
                                        }}
                                        href="https://www.scuttle.co.za/"
                                        className="block px-4 py-1 lg:p-6 text-md font-bold text-yellow-500">
                                        Home
                                    </a>
                                    <a
                                        href="https://www.scuttle.co.za/contact/"
                                        className="block px-4 py-1 lg:p-6 text-md font-bold text-yellow-500">
                                        Contact
                                    </a>
                                    <a
                                        href="https://www.scuttle.co.za/faqs/"
                                        className="block px-4 py-1 lg:p-6 text-md font-bold text-yellow-500">
                                        FAQ's
                                    </a>
                                    <a
                                        href="https://www.scuttle.co.za/adventures-blog/"
                                        className="block px-4 py-1 lg:p-6 text-md font-bold text-yellow-500">
                                        Adventures
                                    </a>
                                    {/* <a
                                        href="https://scuttle.co.za/scuttle-events/"
                                        className="block px-4 py-1 lg:p-6 text-md font-bold text-yellow-500">
                                        Scuttle Events
                                    </a> */}
                                    <a
                                        href="https://www.scuttle.co.za/our-story/"
                                        className="block px-4 py-1 lg:p-6 text-md font-bold text-yellow-500">
                                        About Us
                                    </a>
                                    {user?.attributes && user?.attributes['custom:company'] && <a
                                        href="/rent/admin"
                                        className="block px-4 py-1 lg:p-6 text-md font-bold text-yellow-500"
                                        role="menuitem"
                                    >
                                        Admin Portal
                                    </a>
                                    }
                                    {user ? <><a
                                        href="/rent/account/orders"
                                        className="block px-4 py-1 lg:p-6 text-md font-bold text-yellow-500"
                                        role="menuitem"
                                    >
                                        My Orders
                                    </a>
                                        <a
                                            href="/rent/account/settings"
                                            className="block px-4 py-1 lg:p-6 text-md font-bold text-yellow-500"
                                            role="menuitem"
                                        >
                                            Account Settings
                                        </a>
                                        <a
                                            onClick={onSignout}
                                            className="block px-4 py-1 lg:p-6 text-md font-bold text-yellow-500"
                                            role="menuitem"
                                        >
                                            Sign out
                                        </a>
                                    </> : <a
                                        onClick={toggleLoginModal}
                                        className="block px-4 py-1 lg:p-6 text-md font-bold text-yellow-500"
                                        role="menuitem"
                                    >
                                        Sign in
                                    </a>}

                                </div>
                            </div>
                        </div>

                        <div id="search-content"
                             className={clsx(showSearch ? '' : 'hidden', "relative w-full  bg-white shadow-xl")}>
                            <div className="container mx-auto py-4 text-black">
                                <form onSubmit={handleSubmit}>
                                    <input {...getFieldProps('text')}
                                           onChange={(e) => {
                                               setFieldValue('text', e.target.value);
                                               if (!e.target.value) {
                                                   setSearch({text: null});
                                               }
                                           }}
                                           type="search"
                                           placeholder="Search for a product, brand or category..."
                                           className="w-full text-grey-800 transition focus:outline-none focus:border-transparent p-2 appearance-none leading-normal text-xl lg:text-2xl"/>
                                </form>
                            </div>

                        </div>
                    </nav>
                </Sticky>

                <main>
                    {children}
                </main>
            </div>
        </>
    )
        ;
}